export default "__VITE_ASSET__Dt5mS8RE__"